<template>
    <h1>{{ title }}</h1>
    <h2>{{ dates }}</h2>
    <div class="dontprintthis">
        <button type="button" onclick="window.print()" class="icon"><svg-icon type="mdi" :path="iconPrint"></svg-icon></button>&nbsp;<button type="button" v-on:click="createAndDownloadCSV()" class="icon"><svg-icon type="mdi" :path="iconSave"></svg-icon></button>
        <VueDatePicker v-model="date" :format="format" range :enable-time-picker="false" :six-weeks="'center'" prevent-min-max-navigation ignore-time-validation :max-date="maxDate" :min-date="minDate" @update:model-value="handleDate" />
    </div>
    <div v-if="pendingBalance">
        <svg-icon type="mdi" :path="iconLoading" class="rotate"></svg-icon> {{ $t('balanceReport.loading') }}
    </div>
    <div v-else>
        <div class="printthis">
            <template v-if="balanceData && balanceData.length > 0">                    
                <div class="transactionlist">
                    <div>{{ $t('balanceReport.date') }}</div>
                    <div>{{ $t('balanceReport.parent') }}</div>
                    <div>{{ $t('balanceReport.action') }}</div>
                    <div>{{ $t('balanceReport.note') }}</div>
                    <div class="currency">{{ $t('balanceReport.amount') }}</div>
                    <div class="currency">{{ $t('balanceReport.newBalance') }}</div>
                    <template v-for="(data, index) in balanceData" :key="index">
                        <div>{{ formatDate(new Date(data.Date)) }} {{ formatTime(new Date(data.Date), { hour: 'numeric', minute: 'numeric', second: 'numeric', }) }}</div>
                        <div>{{ data.Parent }}</div>
                        <div>{{ (data.Value<0?$t('balanceReport.actionCredit'):$t('balanceReport.actionDebit')) }}</div>
                        <div>{{ data.Note }}</div>
                        <div class="currency" :class="(data.Value>0?'green':'red')">{{ data.Value }} {{ data.Currency }}</div>
                        <div class="currency">{{ data.Credit }} {{ data.Currency }}</div>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { apiEndpoint, apiVersionParent } from '@/scripts'
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiLoading, mdiPrinter, mdiContentSave } from '@mdi/js'
import axios from 'axios'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import {parseDate, format, formatDate, formatTime} from "@/scripts/dateFunctions.js";
import downloadCSV from "@/scripts/downloadCSV.js";
export default {
    data() {
        return {
            iconLoading: mdiLoading,
            iconPrint: mdiPrinter,
            iconSave: mdiContentSave,
            pending: false,
            error: 0,
            errorHint: "",
            pendingBalance: false,
            balanceData: [],
            date: [new Date(), new Date().setDate(new Date().getDate() + 1)],
            minDate: new Date().setMonth(new Date().getMonth() - 3),
            maxDate: new Date().setDate(new Date().getDate() + 1),
            startDate: new Date(),
            endDate: new Date(),
            format: format,
            formatDate: formatDate,
            formatTime: formatTime
        }
    }, props: {
        shopId: Number,
        shopName: String
    },
    components: {
        SvgIcon,
        VueDatePicker
    },
    mounted() {
        if (this.$route.params.startDate && this.$route.params.endDate) {
            this.startDate = parseDate(this.$route.params.startDate);
            this.endDate = parseDate(this.$route.params.endDate);
        } else {
            this.startDate = new Date();
            this.endDate = new Date()
            this.endDate.setDate(this.endDate.getDate() + 1); 
        }
        this.date = [this.startDate, this.endDate];
        this.loadBalanceReport();
    }, methods: {
        loadBalanceReport(){
            this.pendingBalance = true;
            this.error = 0;
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`
                }
            };
            var s = formatDate(this.startDate).replaceAll("/", "-");
            var e = formatDate(this.endDate).replaceAll("/", "-");
            var endpoint = apiEndpoint + apiVersionParent + "/children/balance/report/" + this.shopId + "?start=" + s + "&end=" + e;
            axios.get(endpoint, config)
                .then(res => {
                this.pendingBalance = false;
                this.balanceData = res.data.Data;
            })
            .catch(error => {
                this.pending = false;
                if (error) {
                    this.error = 100;
                }
            });
        },
        handleDate(date) {
            this.startDate = date[0];
            this.endDate = date[1];
            if (this.shopId > 0) {
                this.$router.push({ name: 'shopManageBalance', params: { shopId: this.shopId, shopName: this.shopName, startDate: formatDate(this.startDate).replaceAll("/", "-"), endDate: formatDate(this.endDate).replaceAll("/", "-") } });
            } else {
                this.$router.push({ name: 'home', params: { startDate: formatDate(this.startDate).replaceAll("/", "-"), endDate: formatDate(this.endDate).replaceAll("/", "-") } });
            }

            this.loadBalanceReport();
        },
        createAndDownloadCSV() {
            let csv = `${this.$t('balanceReport.date')};${this.$t('balanceReport.parent')};${this.$t('balanceReport.action')};${this.$t('balanceReport.note')};${this.$t('balanceReport.amount')};${this.$t('balanceReport.currency')};${this.$t('balanceReport.newBalance')}\n`;
            this.balanceData.forEach((data) => {
                csv += `${formatDate(new Date(data.Date))} ${formatTime(new Date(data.Date), { hour: 'numeric', minute: 'numeric', second: 'numeric', })};${data.Parent};${(data.Value<0?this.$t('balanceReport.actionCredit'):this.$t('balanceReport.actionDebit'))};${data.Note};${data.Value};${data.Currency};${data.Credit}\n`;
            });

            const exportedFilename = this.$t('balanceReport.filename') + this.dates.replaceAll(' ', '') + '.csv';
            downloadCSV(document, csv, exportedFilename);
        }
    }, computed: {
        dates() {
            if (typeof this.startDate === 'object' && this.startDate !== null && 'getDate' in this.startDate && typeof this.endDate === 'object' && this.endDate !== null && 'getDate' in this.endDate)
                return formatDate(this.startDate) + " - " + formatDate(this.endDate);
            else {
                return formatDate(new Date()) + " - " + formatDate(new Date());
            }
        },
        none() {
            if (typeof this.startDate === 'object' && this.startDate !== null && 'getDate' in this.startDate && typeof this.endDate === 'object' && this.endDate !== null && 'getDate' in this.endDate)
                return this.$t("recentList.none").replace("###DATE###", formatDate(this.startDate) + " - " + formatDate(this.endDate));
            else {
                return this.$t("recentList.none").replace("###DATE###", formatDate(new Date()) + " - " + formatDate(new Date()));
            }
        },
        title() {
            return this.$t("balanceReport.title").replace("###SHOPNAME###", this.shopName);
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../scss/master.scss';

.transactionlist {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    max-width: fit-content;
    margin: 0 auto;
    border: 1px solid black;
}

.transactionlist>div {
    text-align: left;
    padding: 10px 20px;
    border: 1px solid black;
}

.transactionlist>div.currency {
    text-align: right;
}

.transactionlist>div:nth-child(-n + 5) {
    font-weight: 600;
}
</style>